<template>
  <div class="my-security-login">
     <div class="warnTip">{{safetyPage.tip7}}</div>
     <div class="myItems">
      <span class="item1">{{safetyPage.oldPass}}</span>
      <el-input v-model="oldPassword"  type="password"></el-input>
      <span class="item3">*</span>
      <span class="item4">{{safetyPage.tip5}}</span>
    </div>
     <div class="myItems">
      <span class="item1">{{safetyPage.newPass}}</span>
      <el-input v-model="newPassword"  type="password"></el-input>
      <span class="item3">*</span>
      <span class="item4">{{safetyPage.tip6}}</span>
    </div>
     <div class="myItems">
      <span class="item1">{{safetyPage.ConfirmPassword}}</span>
      <el-input v-model="newPassword2"  type="password"></el-input>
      <span class="item3">*</span>
      <span class="item4">{{safetyPage.tip3}}</span>
    </div>
    <div class="mytButton">
        <span class="btnConfirm" @click="updatePassword">{{safetyPage.confirm}}</span>
        <span class="btnCancel hide">{{safetyPage.tip9}}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
    }
  },
  computed: {
    safetyPage(){
      return this.$t('safetyPage')
    }
  },
  methods:{
       updatePassword() {
      if (!this.$utils.isPassword(this.oldPassword)) {
          this.$message.error(this.safetyPage.originalpassword);
          return;
        }
      if (!this.$utils.isPassword(this.newPassword)) {
        this.$message.error(this.safetyPage.Newpassword);
         return;
      }
      if (this.newPassword != this.newPassword2) {
        this.$message.error(this.safetyPage.notthesame);
         return;
      }
      let _obj={
        newpassword1: this.newPassword,
        password: this.oldPassword
      };
      this.$nkhttp.http(this.$api.updatePassword,_obj,'post',data=>{
        this.$message.success(this.safetyPage.Loginsuc);
        this.oldPassword = "";
        this.newPassword = "";
        this.newPassword2 = "";
      })
    },
  }
};
</script>